export default {
  profile: {
    backButton: "profile-button-back",
    profileName: "profile-name",
    analytics: "profile-analytics",
    editNameButton: "profile-button-edit-name",
    segmentLabel: "profile-segment-label",
    visitCount: "profile-visit-counter",
    realAvatar: "profile-guest-avatar",
    defaultAvatar: "profile-default-avatar",
    totalSpent: "profile-total-spent",
    averageBill: "profile-average-bill",
    averageTipsPercent: "profile-average-tips-percent",
    favouriteDishBlock: "profile-favourite-dish-block",
    favouriteDishList: "profile-favourite-dish-list",
    tagsEmpty: "profile-tags-empty",
    tagsGroup: (type: string) => `profile-tags-group-${type}`,
    tagsItem: (id: string) => `profile-tags-item-${id}`,
    addTagsButton: "profile-add-tags-button",
    editTagsButton: "profile-edit-tags-button",
    commentsNavigation: "profile-comments-navigation",
    commentsNavPrevButton: "profile-comments-nav-prev-button",
    commentsNavNextButton: "profile-comments-nav-next-button",
    commentsCarousel: "profile-comments-carousel",
    commentsItem: "profile-comments-item",
    commentsEmpty: "profile-comments-empty",
    addCommentButton: "profile-add-comment-button",
    visitHistoryTitle: "profile-visit-history-title",
    visitHistoryEmpty: "profile-visit-history-empty",
    visitBill: "profile-visit-bill",
    visitTableNumber: "profile-visit-table-number",
    showBillButton: "profile-show-bill-button",
    visitReviewItem: "profile-visit-review-item",
    visitReviewStars: "profile-visit-review-stars",
    visitReviewScore: "profile-visit-review-score",
    visitReviewText: "profile-visit-review-text",
    visitReviewEmptyText: "profile-visit-review-empty-text",
    visitDishItem: "profile-visit-dish-item",
    visitDishScore: "profile-visit-dish-score",
    visitDishTitle: "profile-visit-dish-title",
    networkDropDown: "profile-network-drop-down",
    networkNavigation: "profile-network-navigation",
    networkNavPrevButton: "profile-network-nav-prev-button",
    networkNavNextButton: "profile-network-nav-next-button",
    networkCarousel: "profile-network-carousel",
    networkItem: "profile-network-item",
    networkRestaurant: "profile-network-restaurant",
    networkSegmentLabel: "profile-network-segment-label",
  },
  modals: {
    editName: {
      input: "modals-edit-name-input",
      saveButton: "modals-edit-name-save-button",
    },
    addTags: {
      input: "modals-add-tags-input",
      saveButton: "modals-add-tags-save-button",
    },
    operateTags: {
      tagsGroupTitle: (type: string) => `modals-edit-tags-group-title-${type}`,
      tagTitle: "modals-edit-tags-tag-title",
      createTagButton: "modals-edit-tags-create-button",
      saveButton: "modals-edit-tags-save-button",
      cancelButton: "modals-edit-tags-cancel-button",
    },
    addComment: {
      input: "modals-add-comment-input",
      saveButton: "modals-add-comment-save-button",
    },
    analyticsPeriods: {
      saveButton: "modals-analytics-periods-save-button",
      cancelButton: "modals-analytics-periods-cancel-button",
      monthItem: (month: number) => `modals-analytics-periods-month-item-${month}`,
    },
    analyticsV2Periods: {
      weekButton: "modals-analytics-v2-periods-week-button",
      monthButton: "modals-analytics-v2-periods-month-button",
      dateSelect: "modals-analytics-v2-periods-date-select",
      periodOption: (period: string, index: number) =>
        `modals-analytics-v2-periods-${period}-option-${index}`,
      applyButton: "modals-analytics-v2-periods-apply-button",
      cancelButton: "modals-analytics-v2-periods-cancel-button",
    },
    common: {
      closeButton: "modals-common-close-button",
    },
  },
  sidebar: {
    sideMenu: "sidebar-menu",
    logo: "sidebar-logo",
    restaurantButton: "sidebar-restaurant-button",
    dashboardButton: "sidebar-dashboard-button",
    guestBaseButton: "sidebar-guest-base-button",
    offersButton: "sidebar-offers-button",
    logOutButton: "sidebar-log-out-button",
    mobileLogo: "sidebar-mobile-logo",
    mobileRestaurantLogo: "sidebar-mobile-restaurant-button",
    mobileBurgerMenu: "sidebar-mobile-burger-menu",
  },
  home: {
    title: "home-title",
    restaurantItem: "home-restaurant-item",
    restaurantItemName: "home-restaurant-item-name",
    restaurantItemAddress: "home-restaurant-item-address",
    restaurantItemImage: "home-restaurant-item-image",
  },
  dashboard: {
    title: "dashboard-title",
    choosePeriodButton: "dashboard-choose-period-button",
    loadReportButton: "dashboard-load-report-button",
    warning: "dashboard-warning",
    udoKpi: (kpiName: string) => `dashboard-udo-kpi-${kpiName}`,
    udoGuests: (kpiName: string) => `dashboard-udo-guests-${kpiName}`,
    udoGuestsByType: (kpiName: string) => `dashboard-udo-guests-by-type-${kpiName}`,
    udoGuestContentment: (kpiName: string) => `dashboard-udo-guest-contentment-${kpiName}`,
    udoMaleGraff: (kpiName: string) => `dashboard-male-graff-${kpiName}`,
    udoAgeGraff: (kpiName: string) => `dashboard-age-graff-${kpiName}`,
    udoSaleryGraff: (kpiName: string) => `dashboard-salery-graff-${kpiName}`,
    waiters: {
      name: "dashboard-waiters-name",
      avrBill: "dashboard-waiters-avr-bill",
      tipsShare: "dashboard-waiters-tips-share",
      totalTipsSum: "dashboard-waiters-total-tips-sum",
      orderCount: "dashboard-waiters-order-count",
      totalOrderSum: "dashboard-waiters-total-order-sum",
      avrRate: "dashboard-waiters-avr-rate",
      rateCount: "dashboard-waiters-rate-count",
    },
  },
  guestBase: {
    title: "guest-base-title",
    dataTable: {
      emptyState: "guest-base-data-table-empty-state",
      pagination: {
        prevButton: "guest-base-data-table-pagination-prev-button",
        nextButton: "guest-base-data-table-pagination-next-button",
        pageNumber: (number: number | undefined) =>
          `guest-base-data-table-pagination-page-number-${number}`,
      },
      totalRecords: "guest-base-data-table-total-records",
      column: (columnName: string) => `guest-base-data-table-column-${columnName}`,
    },
    choosePeriodButton: "guest-base-choose-period-button",
    periodMenu: "guest-base-period-menu",
    segments: {
      other: "guest-base-segment-other-${segment}",
      regular: (segmentName: string) => `guest-base-segment-regular-${segmentName}`,
      total: "guest-base-segment-total",
      deleteDialog: {
        text: "guest-base-segment-delete-dialog-text",
        deleteButton: "guest-base-segment-delete-dialog-delete-button",
      },
      dialog: {
        nameInput: "guest-base-segment-dialog-name-input",
        valueInput: "guest-base-segment-dialog-value-input",
        parameterSelect: "guest-base-segment-dialog-parameter-select",
        timeRangeSelect: "guest-base-segment-dialog-time-range-select",
        ruleSelect: "guest-base-segment-dialog-rule-select",
        saveButton: "guest-base-segment-dialog-save-button",
        deleteButton: "guest-base-segment-dialog-delete-button",
      },
      systemSegmentsDialog: {
        segmentCard: "guest-base-system-segments-dialog-segment-card",
        saveButton: "guest-base-system-segments-dialog-save-button",
        rangeSlider: "guest-base-system-segments-dialog-range-slider",
      },
      settingsMenu: {
        openSettingsButton: "guest-base-segment-settings-menu-open-settings-button",
        item: "guest-base-segment-settings-menu-item",
        createSegmentButton: "guest-base-segment-settings-menu-create-segment-button",
      },
    },
  },
  errorScreen: {
    block: "error-screen-block",
    title: "error-screen-title",
    description: "error-screen-description",
    cat: "error-screen-back-cat",
  },
  offers: {
    title: "offers-title",
    analytics: {
      title: "offers-analytics-title",
      sentOffers: "offers-analytics-sent-offers",
      usedOffers: "offers-analytics-used-offers",
      choosePeriodButton: "offers-analytics-choose-period-button",
      periodMenu: "offers-analytics-period-menu",
    },
    specials: {
      title: "offers-specials-title",
      createButton: "offers-specials-create-offer-button",
      item: {
        rule: "offers-specials-item-rule",
        title: "offers-specials-item-title",
        pauseButton: "offers-specials-item-pause-button",
        used: "offers-specials-item-used",
        sent: "offers-specials-item-sent",
        conversion: "offers-specials-item-conversion",
        image: "offers-specials-item-image",
      },
      emptyState: {
        title: "offers-specials-empty-state-title",
        text: "offers-specials-empty-state-text",
      },
    },
    createDialog: {
      option: (type: string) => `offers-create-dialog-option-${type}`,
      continueButton: "offers-create-dialog-continue-button",
    },
    createCampaign: {
      backButton: "offers-create-campaign-back-button",
      continueButton: "offers-create-campaign-continue-button",
      template: (type: string) => `offers-create-campaign-template-${type}`,
      progressStep: (steps: string) => `offers-create-campaign-progress-step-${steps}`,
    },
  },
}
